import type { CreateSessionRequest } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { AuthService } from 'src/utils/api';
import { API_ERROR_MESSAGES, SESSION_STORAGE_KEYS } from 'src/utils/constants';

import { toast } from 'src/components/snackbar';

const createSession = async (data: CreateSessionRequest): Promise<string> => {
  const response = await AuthService.createSession(data);
  return response;
};

export function useCreateSession() {
  const { mutate } = useMutation({
    mutationFn: createSession,
    onSuccess: (sessionId) => {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.SESSION_ID, sessionId);
    },
    onError: (error) => {
      toast.error(API_ERROR_MESSAGES.SESSION_CREATION_ERROR);
      console.error(error);
    },
  });

  return mutate;
}
